import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3w164a: FaireProductEntity = {
  token: "p_x3w164a",
  type: "product",
  name: "Artisan Lemonade",
  brandName: "Fresh Press Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e91bd133da97249615f4e7b28d4749bdb811474cb26606fcdacc5e617f253e7.webp",
  priceDollars: 5,
  description: "Small-batch artisan lemonade",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "artisanal"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e91bd133da97249615f4e7b28d4749bdb811474cb26606fcdacc5e617f253e7.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  inStock: true,
};
